import React, {useEffect, useState} from 'react';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import BackServer from "../../api/BackServer";
import {Container} from "@mui/material";
import BreadPath from "../BreadPath/BreadPath";
import {MDBContainer} from "mdb-react-ui-kit";
import OneProductDetail from "../OneProductDetail/OneProductDetail";
import {baseUrl_back} from "../../api/BaseUrl";
import  C1M from "../../Images/1M.png"
import  C2M from "../../Images/2M.png"
import  C3M from "../../Images/3M.png"
import  C6M from "../../Images/6M.png"
import  C9M from "../../Images/9M.png"
import  C12M from "../../Images/12M.png"
import  C24M from "../../Images/24M.png"
import  XXM from "../../Images/XXM.png"
import OneDigitalProductDetail from "../OneDigitalProductDetail/OneDigitalProductDetail";
const DigitalProductCard = (props) => {
    const params = useParams();
    let navigate = useNavigate();
    {/* eslint-disable-next-line */}
    // ym(92960084,'reachGoal','DetailProduct')
    // var myParams = {perehodVproduct: {product_id: params.product_id}};
    {/* eslint-disable-next-line */}
    // ym(92960084, 'params', {params: myParams});
    // console.log(myParams)
// alert("ss")


    const product_id = params.product_id;
    const [myproducts, setmyproducts] = useState([])
    const [myprodName, setmyprodName] = useState("продукт")
    const [category, setCategory] = useState([])
    const [toggler, setToggler] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    var Fromkey= searchParams.get("Fromkey")
    var Fromlink= searchParams.get("Fromlink")

    let ProdName="-"

    var elmNew={
        "_id": product_id,
        "BuyWithThis": [],
        "Categories": [
            "Tsifrovye_tovary"
        ],
        "Colors": [
            "ALL"
        ],
        "GoodsBrothersID": [],
        "Material": [
            "Цифровой"
        ],
        "ModelOnPfoto": "нет",
        "Price": 1000,
        "RIMG":C1M,
        "PriceBefore": 1100,
        "PriceBeforeShow": true,
        "Rating": 5,
        "Season": [
            "1 год"
        ],
        "Sizes": [
            "ALL"
        ],
        "SizesAvailability": [
            "ALL"
        ],
        "Url": "/products/12M_Premium",
        "Weight": 1,
        "article": "12M_Premium",
        "availability": true,
        "availability_text": "В наличии",
        "components": "Digital",
        "decorativeElements": [
            "нет"
        ],
        "description": [
            "Премиум доступ подразумевает скидку 5% на одежду на маркетплейсе OZON, а также  доступ в Тлеграм-канал и доступ к базе знаний телеграм-бота. Передача промокодов и преимум-доступа происходит путем направления пользователю промокода на активацию или активации его профиля в Телеграмм автоматизированно. Для автоматической активации Телеграм-аккаунта необходимо привязать свой профиль к учетной записи в нашем телеграмм-боте"
        ],
        "feedback": [],
        "imageUrl": "1M.png",
        "imagesUrls": [],
        "maxTermal": 0,
        "micro_description": "-",
        "minTermal": 0,
        "mini_description": "-",
        "modelFeatures": [
            "цифровой товар"
        ],
        "name": "Предоставление премиум доступа на  12 месяцев",
        "show": true,
        "sort_index": -1,
        "sports": [
            "any"
        ],
        "tags": []
    }
    if (product_id=="Cyfra_1M"){
        ProdName="Предоставление премиум доступа на  1 месяц"
        elmNew["ProdName"]="Предоставление премиум доступа на  1 месяц"
        elmNew["name"]="Премиум доступ на 1 месяц"
        elmNew ["micro_description"]= "Предоставление премиум доступа на  1 месяц"
        elmNew ["mini_description"]= "Предоставление премиум доступа на  1 месяц"
        elmNew ["article"]= "1M_Premium"
        elmNew ["imageUrl"]= "1M.png"
        elmNew["Price"]=130
        elmNew["PriceBefore"]=150
        elmNew["RIMG"]=C1M
        elmNew["Season"]=["1 месяц"]

    }

    if (product_id=="Cyfra_2M"){
        ProdName="Предоставление премиум доступа на  2 месяца"
        elmNew["ProdName"]="Предоставление премиум доступа на  2 месяца"
        elmNew["name"]="Премиум доступ на 2 месяца"
        elmNew ["micro_description"]= "Предоставление премиум доступа на  2 месяца"
        elmNew ["mini_description"]= "Предоставление премиум доступа на  2 месяца"
        elmNew ["article"]= "2M_Premium"
        elmNew ["imageUrl"]= "2M.png"
        elmNew["Price"]=240
        elmNew["PriceBefore"]=300
        elmNew["RIMG"]=C2M
        elmNew["Season"]=["2 месяца"]
    }
    if (product_id=="Cyfra_3M"){
        ProdName="Предоставление премиум доступа на  3 месяца"
        elmNew["ProdName"]="Предоставление премиум доступа на  3 месяца"
        elmNew["name"]="Премиум доступ на 3 месяца"
        elmNew ["micro_description"]= "Предоставление премиум доступа на  3 месяца"
        elmNew ["mini_description"]= "Предоставление премиум доступа на  3 месяца"
        elmNew ["article"]= "3M_Premium"
        elmNew ["imageUrl"]= "3M.png"
        elmNew["Price"]=350
        elmNew["PriceBefore"]=450
        elmNew["RIMG"]=C3M
        elmNew["Season"]=["3 месяца"]
    }
    if (product_id=="Cyfra_6M"){
        ProdName="Предоставление премиум доступа на  6 месяцев"
        elmNew["ProdName"]="Предоставление премиум доступа на  6 месяцев"
        elmNew["name"]="Премиум доступ на 3 месяцев"
        elmNew ["micro_description"]= "Предоставление премиум доступа на  6 месяцев"
        elmNew ["mini_description"]= "Предоставление премиум доступа на  6 месяцев"
        elmNew ["article"]= "6M_Premium"
        elmNew ["imageUrl"]= "6M.png"
        elmNew["Price"]=550
        elmNew["PriceBefore"]=900
        elmNew["RIMG"]=C6M
        elmNew["Season"]=["6 месяцев"]
    }

    if (product_id=="Cyfra_9M"){
        ProdName="Предоставление премиум доступа на  9 месяцев"
        elmNew["ProdName"]="Предоставление премиум доступа на  9 месяцев"
        elmNew["name"]="Премиум доступ на 9 месяцев"
        elmNew ["micro_description"]= "Предоставление премиум доступа на  9 месяцев"
        elmNew ["mini_description"]= "Предоставление премиум доступа на  9 месяцев"
        elmNew ["article"]= "9M_Premium"
        elmNew ["imageUrl"]= "9M.png"
        elmNew["Price"]=700
        elmNew["PriceBefore"]=1350
        elmNew["RIMG"]=C9M
        elmNew["Season"]=["9 месяцев"]
    }
    if (product_id=="Cyfra_12M"){
        ProdName="Предоставление премиум доступа на  12 месяцев"
        elmNew["ProdName"]="Предоставление премиум доступа на  12 месяцев"
        elmNew["name"]="Премиум доступ на 12 месяцев"
        elmNew ["micro_description"]= "Предоставление премиум доступа на  12 месяцев"
        elmNew ["mini_description"]= "Предоставление премиум доступа на  12 месяцев"
        elmNew ["article"]= "12M_Premium"
        elmNew ["imageUrl"]= "12M.png"
        elmNew["Price"]=1000
        elmNew["PriceBefore"]=1800
        elmNew["RIMG"]=C12M
        elmNew["Season"]=["12 месяцев"]
    }
    if (product_id=="Cyfra_24M"){
        ProdName="Предоставление премиум доступа на  24 месяца"
        elmNew["ProdName"]="Предоставление премиум доступа на  24 месяца"
        elmNew["name"]="Премиум доступ на 24 месяца"
        elmNew ["micro_description"]= "Предоставление премиум доступа на  24 месяца"
        elmNew ["mini_description"]= "Предоставление премиум доступа на  24 месяца"
        elmNew ["article"]= "24M_Premium"
        elmNew ["imageUrl"]= "24M.png"
        elmNew["Price"]=1600
        elmNew["PriceBefore"]=3600
        elmNew["RIMG"]=C24M
        elmNew["Season"]=["24 месяца"]
    }
    if (product_id=="Cyfra_XM"){
        ProdName="Предоставление премиум доступа на индивидуальных условиях"
        elmNew["ProdName"]="Предоставление премиум доступа на индивидуальных условиях"
        elmNew["name"]="Премиум доступ на индивидуальных условиях"
        elmNew ["micro_description"]= "Предоставление премиум доступа на индивидуальных условиях"
        elmNew ["mini_description"]= "Предоставление премиум доступа на индивидуальных условиях"
        elmNew ["article"]= "XXM_Premium"
        elmNew ["imageUrl"]= "XXM.png"
        elmNew["RIMG"]=XXM
        elmNew["Price"]=9999999
        elmNew["PriceBefore"]=999999999
        elmNew["Season"]=["По договоренности"]
    }

    // console.log("dd")
    // const getProducts = async () => {
    //     const response = await BackServer.GetProductById(product_id)
    //     {setmyprodName(response.message.products[0].name)}
    //     setmyproducts(response.message.products)
    // }


    const callup = (len) => {
        props.callbackX(len)

    }
    const Bread=[{key:"Главная", link:"/"}, {key:"Каталог", link:"/newcatalog"},{key:ProdName, link:"/products/"+product_id} ]
    // useEffect(() => {
    //     getProducts()
    // }, [])
    return   (
        <Container  maxWidth="xl">
            <BreadPath key={"ddd"}  path={Bread}/>
            {searchParams["fromCat"]}
            <MDBContainer fluid >
                <OneDigitalProductDetail key={product_id}   callbak={callup} elm={elmNew} label={elmNew.name} img={baseUrl_back+elmNew.imageUrl}  urlx={elmNew.Url} />
            </MDBContainer>

            {/*<OneProductGlass key={"dd"}   callbak={callup} elm={myproducts} label={myproducts.name} img={baseUrl_back+myproducts.imageUrl}  urlx={myproducts.Url} />*/}
        </Container>
    );
};

export default DigitalProductCard;